module.exports = __webpack_public_path__ + "static/media/angrybirds.504e2e4a.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/angrybirds.webm
// module id = 51
// module chunks = 0